import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faBan } from '@fortawesome/pro-regular-svg-icons/faBan';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { noop } from 'ui-components/default-props/noop';

import style from './note-icon.module.less';
import { updateFulfillmentPlanNoteRequest } from '../../../../store/entities/entities.actions';

/**
 * @param {object} props
 * @param {string} [props.fulfillmentPlanId]
 * @param {string} [props.type]
 * @param {import('../../../../prop-types/intl').MessageDescriptorPropType} props.titleTranslation
 * @param {(value: string) => void} [props.onEditAction]
 * @param {(value: boolean) => void} props.togglePopover
 * @param {string} [props.message]
 * @param {() => void} [props.stopPropagate]
 * @returns {JSX.Element}
 */
export const EditNotePopoverContent = ({
  type = '',
  fulfillmentPlanId,
  togglePopover,
  message = '',
  titleTranslation,
  stopPropagate = noop,
  onEditAction,
}) => {
  const dispatch = useDispatch();
  const textAreaRef = useRef(null);

  const [noteText, setNoteText] = useState(message);

  useEffect(() => {
    textAreaRef.current.focus();
    textAreaRef.current.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
  }, []);

  const onTextChange = useCallback((e) => {
    setNoteText(e.target.value);
  }, []);

  const saveNote = useCallback(
    (e) => {
      e.stopPropagation();
      const updatedNote = {
        body: noteText.trim(),
        type,
      };
      if (onEditAction) {
        onEditAction(updatedNote.body);
        togglePopover(false);
        return;
      }
      dispatch(
        updateFulfillmentPlanNoteRequest({
          fulfillmentPlanId,
          note: updatedNote,
        }),
      );
      togglePopover(false);
    },
    [noteText, type, onEditAction, dispatch, fulfillmentPlanId, togglePopover],
  );

  const cancelUpdate = useCallback(
    (e) => {
      e.stopPropagation();
      setNoteText(message);
      togglePopover(false);
    },
    [message, togglePopover],
  );

  return (
    <div className={style['note-tooltip']} data-testid='edit-note-popover-content' onClick={stopPropagate} onDoubleClick={stopPropagate}>
      <div className={style['note-title']}>
        <FormattedMessage {...titleTranslation} />
      </div>
      <div className={classnames(style['note-body'], style['edit-mode'])}>
        <textarea ref={textAreaRef} className={style['note-body-textarea']} onChange={onTextChange} tabIndex={0} value={noteText} />
        <div className={style['note-buttons']}>
          <button className={classnames('button', style.save)} onClick={saveNote} tabIndex={0}>
            <FontAwesomeIcon icon={faCheck} />
          </button>
          <button className='button cancel' onClick={cancelUpdate} tabIndex={0}>
            <FontAwesomeIcon icon={faBan} />
          </button>
        </div>
      </div>
    </div>
  );
};
